import {IStation, IImomoResponsePaginated} from '../api/api.types';
import {IStationApi} from '../api/station-api.service';
import {StateService} from 'angular-ui-router';

export default class StationManagerController {
  static $inject = ['$state', 'stationApi', '$mdDialog', '$translate', '$location'];

  stations:IStation[];
  selectedStations:IStation[];
  stationsPromise:ng.IPromise<void>;
  siteSearchText: string;
  paginationSettings: {
    offset: number,
    pageSize: number,
    count?: number,
    currentPage?: number
  };
  order:string;
  isOpen:boolean = false;

  constructor(
    private $state:StateService, 
    private stationApi:IStationApi,
    private $mdDialog: ng.material.IDialogService,
    private $translate:ng.translate.ITranslateService,
    private $location: ng.ILocationService) {

    this.selectedStations = [];
    this.stations = [];
    this.paginationSettings = {
      offset: this.$location.search().offset || 0,
      pageSize: 10,
      currentPage: this.$location.search().offset ? parseInt(this.$location.search().offset) + 1 : 1
    };
    this.order = this.$location.search().order;
    this.onOrderChange = this.onOrderChange.bind(this);
    this.getStations();
  }

  get isStationSelected() {
    return this.selectedStations.length > 0;
  }

  get isSelectedStationVirtual() {
    return this.selectedStation.isVirtual;
  }

  get selectedStation() {
    return this.selectedStations[0];
  }

  newStation = () => {
    this.$state.go('station.creator');
  };

  newVirtualStation = () => {
    this.$state.go('station.creatorVirtual');
  };

  showForecastModels() {
    this.$state.go('station.forecastModels',
      {stationId: this.selectedStation.id});
  };

  showSnowData() {
    this.$state.go('station.snowData',
        {stationId: this.selectedStation.id});
  }

  showHistoricData() {
    this.$state.go('station.historicNorm',
        {stationId: this.selectedStation.id});
  }

  showStationCurve() {
    this.$state.go('station.curve',
        {stationId: this.selectedStation.id});
  }

  showStationTimeseries() {
    this.$state.go('station.timeseries',
        {stationId: this.selectedStation.id});
  }

  editStation() {
    this.$state.go('station.details',
        {stationId: this.selectedStation.id});
  }

  deleteStation(id: number) {
    let confirm = this.$mdDialog.confirm()
        .textContent(this.$translate.instant('DELETE_CONFIRMATION', {item: this.selectedStation.siteName}))
        .ok(this.$translate.instant('DELETE'))
        .cancel(this.$translate.instant('CANCEL'));

    this.$mdDialog.show(confirm).then(() => {
      this.stationApi.deleteDischargeStation(id)
        .then(() => {
          this.getStations();
          this.selectedStations = [];
        })
    });
  }

  private getStations() {
    this.stationsPromise = this.stationApi.getPaginatedDischargeStations(this.paginationSettings.pageSize, this.paginationSettings.offset, this.order)
        .then(this.onStationsReady);
  }

  onOrderChange(order: string) {
    this.getStations()
    this.$location.search({
      offset: this.paginationSettings.offset,
      order: this.order
    });
  }

  onPageChange(page: number) {
    this.paginationSettings.offset = page - 1;
    this.getStations();

    this.$location.search({
      offset: this.paginationSettings.offset,
      order: this.order
    });
  }

  onSiteSearchTextChange() {
    this.stationApi.searchDischargeStations(this.siteSearchText)
      .then((stations) => {
        this.stations = stations;
      })
  }

  private onStationsReady = (stationsPaginated:IImomoResponsePaginated<IStation>) => {
    this.stations = stationsPaginated.resources;
    this.paginationSettings.count = stationsPaginated.count;
  }
}



/** WEBPACK FOOTER **
 ** ./app/station/manager.controller.ts
 **/